import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BankAccount\CreateBankAccountController::__invoke
* @see app/Http/Controllers/BankAccount/CreateBankAccountController.php
* @route '/api/bank-account'
*/
const CreateBankAccountController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateBankAccountController.url(options),
    method: 'post',
})

CreateBankAccountController.definition = {
    methods: ["post"],
    url: '/api/bank-account',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BankAccount\CreateBankAccountController::__invoke
* @see app/Http/Controllers/BankAccount/CreateBankAccountController.php
* @route '/api/bank-account'
*/
CreateBankAccountController.url = (options?: RouteQueryOptions) => {
    return CreateBankAccountController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BankAccount\CreateBankAccountController::__invoke
* @see app/Http/Controllers/BankAccount/CreateBankAccountController.php
* @route '/api/bank-account'
*/
CreateBankAccountController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateBankAccountController.url(options),
    method: 'post',
})

export default CreateBankAccountController